/**
 * Custom exception.
 */
export default class AbstractException extends Error {
}
//# sourceMappingURL=AbstractException.js.map